import { useSessionStore } from '@/hooks/useSessionStore';
import { useAuthCheck } from '@/hooks/useAuthCheck';
import { CheckFilledIcon } from '@/components/Icons';
import { PLAN_MAP_PERMISSION } from '@/config';
import { getSubscriptionStatus } from '@/service/subscription';
import { cn } from '@/utils';
import { useRequest } from 'ahooks';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import ChargeTabs from './components/ChargeTabs';
import TrainedURL from '@/assets/images/recharge/trained.png';
import PricingFAQ from './components/Faq';
import { useAudioPlayerStore } from '@/state/audio-player-store';

const Recharge = () => {
  const { pause } = useAudioPlayerStore();
  useEffect(() => {
    pause();
  }, []);
  const sessionStore = useSessionStore();
  useAuthCheck();
  const { session } = sessionStore;
  const { historyId } = useParams<{ historyId: string }>();

  const currentPermission = PLAN_MAP_PERMISSION[session.user.plan.key];
  const { cancel, run: runSubscriptionStatus } = useRequest((id: string) => getSubscriptionStatus({ historyId: id }), {
    manual: true,
    pollingInterval: 2000,
    onSuccess: (data) => {
      if (data) {
        const {
          data: { is_paid },
        } = data;
        if (is_paid) {
          toast('Plan Change Successful', {
            description: 'Your plan has been changed successfully.',
          });
          setTimeout(() => {
            window.location.replace('/');
          }, 2000);
          cancel();
        }
      }
    },
  });

  useEffect(() => {
    if (historyId && historyId !== 'index.html') {
      runSubscriptionStatus(historyId);
    }
  }, [historyId, runSubscriptionStatus]);

  return (
    <div className="bg-jen-background-secondary pb-jen-spacing-96 w-full  px-[8px] lg:px-0">
      <div className="max-w-[1050px] mx-auto pt-jen-spacing-96">
        <div className="text-jen-size-heading-07 text-jen-interactive-tertiary">SUBSCRIPTION</div>
        <div className="flex justify-between flex-col lg:flex-row gap-[10px]">
          <div className="mt-jen-spacing-8 text-[64px] leading-[64px] lg:text-jen-size-heading-display">
            Set the tempo for your creativity.
          </div>
          <div className="mt-[20px]">
            <div className="h-[66px] flex flex-row gap-4 items-center justify-center w-[281px] p-[10px] border border-jen-orange rounded-md text-jen-orange">
              <img className="w-[44px] h-[44px]" src={TrainedURL} />
              <p className="text-[16px] text-left !leading-[18px] tracking-tight">The Jen Audio Model has been Fairly Trained certified.</p>
            </div>
          </div>
        </div>

        <ChargeTabs />
        <div className="bg-white p-6 mt-6 rounded-xl border border-jen-border flex justify-between items-center">
          <div className="">Out of credits?</div>
          <div>
            {currentPermission && (
              <form action={`/api/v1/payment/credit_topup`} method="post">
                <button type="submit" className="border p-2 border-black/50 text-jen-interactive-secondary rounded-lg">
                  Purchase {currentPermission.topup.credit} Credits - USD ${(currentPermission.topup.price / 100).toFixed(2)}
                </button>
              </form>
            )}
          </div>
        </div>
        <PricingFAQ />
      </div>
    </div>
  );
};

export const CreditPurchase = () => {
  return (
    <div className="mt-[24px] p-[24px] w-full  border-jen-border border rounded-[16px] flex items-center justify-between flex-col lg:flex-row">
      <div className=" text-jen-size-heading-02 mb-[8px] lg:mb-0">Out of credits?</div>
      <div className="flex gap-[16px] flex-col lg:flex-row">
        <div className=" tracking-[-0.34px] border-jen-interactive-secondary rounded-lg border py-[12px] px-[30px]">
          Purchase 100 Credits - USD $3.00
        </div>
        <div className=" tracking-[-0.34px] border-jen-interactive-secondary rounded-lg border py-[12px] px-[30px]">
          Purchase 100 Credits - USD $3.00
        </div>
      </div>
    </div>
  );
};

export const UpgradeButton = ({
  className,
  onclick,

  skuKey,
  currenActivePrice,
  price,
  isActive,
}: {
  className?: string;
  onclick?: () => void;
  skuKey: string;
  currenActivePrice: number;
  price: number;
  isActive?: boolean;
}) => {
  const name = (() => {
    if (isActive) {
      return 'Current Plan';
    }
    if (price > currenActivePrice) {
      return 'Upgrade';
    }
    return 'Downgrade';
  })();
  const renderButton = () => {
    return (
      <button
        type="submit"
        className={cn(
          className,
          'cursor-pointer px-jen-spacing-16 py-jen-spacing-12 w-full border rounded-jen-spacing-8 border-jen-border flex justify-center items-center hover:opacity-80',
          {
            ' cursor-not-allowed text-jen-disabled': isActive,
          },
          {
            'bg-jen-interactive-primary text-jen-content-primary-contrast': price > currenActivePrice,
          },
        )}
      >
        {isActive && <CheckFilledIcon />}
        {name}
      </button>
    );
  };
  if (isActive) {
    return renderButton();
  }
  return (
    <form action={`/api/v1/plan/subscription/${skuKey}`} method="post">
      {renderButton()}
    </form>
  );
};

export default Recharge;
